// extracted by mini-css-extract-plugin
export var carrierIcon = "_ug-0";
export var carrierLogo = "_ug-1";
export var detailsSection = "_ug-2";